import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { AppConfigService } from './shared/services/app-config.service';
import { AuthService } from './shared/services/auth.service';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HomeComponent } from './home/home.component';
import { FirstTimeFileUploadComponent } from './file-upload/components/first-time-file-upload/first-time-file-upload.component';
import { RepeatFileUploadComponent } from './file-upload/components/repeat-file-upload/repeat-file-upload.component';
import { FileUploadStepComponent } from './file-upload/components/file-upload-step/file-upload-step.component';
import { UploadFilesHeaderComponent } from './file-upload/components/upload-files-header/upload-files-header.component';
import { FieldMappingStepComponent } from './file-upload/components/field-mapping-step/field-mapping-step.component';
import { ValidationLogsComponent } from './file-upload/components/validation-logs/validation-logs.component';
import { UploadHistoryComponent } from './upload-history/upload-history.component';
import { UploadComponent } from './file-upload/components/upload/upload.component';

const appConfigInit = (appConfig: AppConfigService, authService: AuthService) => {
  return () => {
    return appConfig.loadAppConfig(authService);
  };
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function authInterceptorInit(auth: AuthInterceptor): () => void {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  return () => {};
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    UploadComponent,
    FirstTimeFileUploadComponent,
    RepeatFileUploadComponent,
    FileUploadStepComponent,
    UploadFilesHeaderComponent,
    FieldMappingStepComponent,
    ValidationLogsComponent,
    UploadHistoryComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    RouterModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_INITIALIZER, useFactory: appConfigInit, multi: true, deps: [AppConfigService, AuthService] },
    { provide: APP_INITIALIZER, useFactory: authInterceptorInit, multi: true, deps: [AuthInterceptor] },
    provideAnimationsAsync(),
    provideHttpClient(),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
